import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedbackMenuItem: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-menu-item',
		defaultMessage: 'Give feedback',
		description: 'Settings navigation menu link which opens the feedback modal',
	},
	feedbackTitleV2: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-v-2',
		defaultMessage: 'Give feedback for the virtual service agent',
		description:
			'Title of the modal dialog where users can share feedback about the JSM virtual service agent',
	},
	feedbackTitleDetails: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-details',
		defaultMessage: 'Share your thoughts on how we can improve this experience.',
		description:
			'Description of a modal dialog where users can leave feedback for the virtual service agent',
	},
	feedbackTitleDetailsContactSupport: {
		id: 'spa-apps-sidebar-servicedesk.common.virtual-agent.nested-nav.feedback-menu-item.feedback-title-details-contact-support',
		defaultMessage: 'If you’re having technical issues, <link>contact Support</link>.',
		description:
			'Message hinting the user to contact the support team if they are trying to report a bug from a feedback dialog',
	},
});
